const Button = ({
	type = 'Button',
	action = 'submit',
	disabled = false,
	text,
	handleClick = null,
	handleSubmit = null,
	withTopMargin = true,
	extraClasses = '',
	id = '', // Ajout de la props id
}) => {
	return (
		<>
			{type === 'Button' ? (
				<button
					type={action}
					id={id} // Utilisation de la props id
					className={`transition duration-300 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${!disabled
							? 'bg-gray-400 cursor-not-allowed'
							: 'cursor-pointer bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70'
						} ${withTopMargin ? 'mt-10' : 'mt-0'} ${extraClasses}`}
					onClick={handleClick}
					onSubmit={handleSubmit}
					disabled={!disabled}
				>
					{text}
				</button>
			) : (
				<></>
			)}
		</>
	);
};

export default Button;
